"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _localization = require("@lt/localization");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CheckoutExtra = _interopRequireDefault(require("../components/CheckoutExtra"));
var _CheckoutExtraTitle = _interopRequireDefault(require("../components/CheckoutExtraTitle"));
var _styled = require("../components/styled");
var title = _localization.i18n.t('checkout.packageInfo.transfer.title_private');
var subTitle = _localization.i18n.t('checkout.services.transfer');
var CheckoutTransfer = function CheckoutTransfer(props) {
  var className = props.className,
    transferList = props.transferList,
    _onChange = props.onChange,
    uncheckOption = props.uncheckOption,
    chosenOptions = props.chosenOptions;
  var hasTransfers = Boolean(transferList === null || transferList === void 0 ? void 0 : transferList.length);
  return /*#__PURE__*/_react["default"].createElement(_styled.Container, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledBodyContainer, null, /*#__PURE__*/_react["default"].createElement(_CheckoutExtraTitle["default"], {
    title: title,
    subTitle: subTitle
  }), hasTransfers ? transferList.map(function (transfer) {
    return /*#__PURE__*/_react["default"].createElement(_CheckoutExtra["default"], (0, _extends2["default"])({}, transfer, {
      key: transfer.id,
      chosenOptions: chosenOptions,
      uncheckOption: uncheckOption,
      onChange: function onChange(option) {
        return _onChange(option);
      }
    }));
  }) : null));
};
var StyledBodyContainer = _styledComponents["default"].div.withConfig({
  displayName: "CheckoutTransfer__StyledBodyContainer",
  componentId: "sc-1ryfi1r-0"
})(["background:#fff;padding:16px;"]);
var _default = exports["default"] = CheckoutTransfer;